import React from 'react'
import { graphql } from 'gatsby'
import { get } from 'lodash'
import Img from 'gatsby-image'
import { Row, Col } from 'reactstrap'
import Layout from '../components/layout/Layout'
import SEO from '../components/seo/SEO'
import NewsletterSignupMC from '../components/newsletterSignupMC/NewsletterSignupMC'
import BlogItem from '../components/blogItem/BlogItem'

class NewsLetter extends React.Component {
  render() {
    const pageTitle = 'Sign Up for our Curated Weekly Newsletter'
    const pageDescription = 'We are here to answer any questions you may have about Gardenlife Pro, our site or the reviews. Reach out to us and we’ll respond as soon as we can.'

    const siteConfig = get(this, 'props.data.site.siteMetadata')
    const seoConfig = {
      ...siteConfig,
      url: get(this, 'props.location.href', `https://www.gardenlifepro.com/newsletter/`),
      title: `${pageTitle} - ${get(this, 'props.data.site.siteMetadata.name')}`,
      description: pageDescription
    }

    return (
      <Layout location={this.props.location}>
        <SEO postData={{}} postImage={''} isBlogPost={false} config={seoConfig}/>
        <div className="page__container">
          <h1>{pageTitle}</h1>
          <h2 className="my-4">Life is Too Short for Bad Articles</h2>
          <Row style={{ border: "3px dotted #DB3946", padding: "20px 5px" }}>
            <Col xs={12} sm={3} className="hidden-xs-down">
              <Img fluid={{...this.props.data.profile.childImageSharp.fluid}} alt="Jason Editor of GardenlifePro"/>
            </Col>
            <Col xs={12} sm={9}>
              Get a selection of free gardening articles once a week <span style={{ borderBottom: "3px solid #DB3946"  }}><strong>hand-picked by Jason</strong></span>, our Chief Editor, that are seasonal, relevant and well written.
              <br/><br/>
              <NewsletterSignupMC align="left" buttonText="Sign up to newsletter"/>
              <div style={{ fontSize: "10px", fontWeight: "300", fontStyle: "italic" }}>
                We hate spam even more than you do, you can unsubscribe at anytime.
              </div>
            </Col>
          </Row>
          <br/>
          <h2 className="mt-5">Top Gardening Blogs and Magazines</h2>
          <p>Here is a list of the top gardening blogs, magazines and publications that we monitor and hand-pick the best articles from.</p>

          <BlogItem
            title='The Guardian'
            description='The Gardens section of the U.K.-based Guardian newspaper offers profiles of distinguished gardens, plant-of-the-week profiles, and gardening advice columns. It also offers general gardening news and interest pieces. '
            url='https://www.theguardian.com/lifeandstyle/gardens'
            />
<BlogItem
            title='The Telegraph Gardening'
            description='This blog is the online component of the U.K.-based Telegraph newspaper’s gardening section. They feature gardening trends as well as news from the gardening world. '
            url='https://www.telegraph.co.uk/gardening/'
            />
<BlogItem
            title='The Royal Horticultural Society'
            description='The Royal Horticultural Society is the UK’s leading gardening charity. They aim to enrich everyone’s life through plants, and make the UK a greener and more beautiful place.'
            url='https://www.rhs.org.uk/'
            />
<BlogItem
            title='Raise Your Garden'
            description='I’m Laura, an avid gardener who loves getting my hands dirty working in the home and garden. DIY projects are a way of life, stretching me and pushing me to try new ideas that will cultivate my yard. I love sharing what I’ve learned with you and equally enjoy your insights. Growing organic produce is my pride and joy. Eating and cooking it even better. Thanks for checking out my home and garden blog.'
            favoriteURL='http://www.raiseyourgarden.com/home/biggest-best-tomatoes-using-fish-heads-aspirin-water-tubes'
            favoriteAnchor='Biggest & best tomatoes using fish heads, aspirin & water tubes'
            />
<BlogItem
            title='Alaska Master Gardener'
            description='This blog is a simple and effective way for Alaska Master Gardeners to volunteer by sharing their knowledge and expertise about Alaska gardening. '
            url='https://alaskamastergardener.community.uaf.edu/'
            />
<BlogItem
            title='Mother Earth News'
            description='At MOTHER EARTH NEWS, we have been educating folks about the benefits of self-reliance for 50 years. That includes researching and sourcing the best books and products to help individuals master the skills they need in times like these and beyond.'
            url='https://www.motherearthnews.com/'
            />
<BlogItem
            title='Gardening Know How'
            description=''
            url='https://www.gardeningknowhow.com/'
            />
<BlogItem
            title='Deep Green Permaculture'
            description='Deep Green Permaculture – teaching people how to work with nature, empowering people to live sustainably! We’re an educational website with lots of practical information and easy to follow DIY instructional guides on a wide range of topics such as permaculture (ecological gardening), urban agriculture, food forest gardening, backyard orchard culture, organic gardening, and more. Because permaculture is about more than just growing food, you’ll also find plenty of useful information on sustainable living, health and wellbeing here too.'
            url='https://deepgreenpermaculture.com/'
            />
<BlogItem
            title='Urban Turnip'
            description='Urban Turnip is blog for space-stretched city gardeners. It covers topics like container growing, house plants, gardening tools, and more.'
            url='https://www.urbanturnip.org/'
            />
<BlogItem
            title='Laidback Gardener'
            description='A daily gardening blog about all aspects of gardening, seen from the “less is more” approach. Written by a garden maniac, author of over 50 books on gardening, with 40 years of experience. There are 2,000 articles and counting, so what are you waiting for?'
            url='https://laidbackgardener.blog/'
            />
<BlogItem
            title='Plants Bulbs Seeds'
            description='Gardening has given me a wealth of pleasure and well-being. I am a firm believer in making the most of nature and the outdoors to improve ourselves both mentally and physically.
            PlantsBulbsSeeds is all about helping people get the most from their outdoor space with friendly advice, tips and inspiration.'
            url='https://plantsbulbsseeds.com/'
            />
<BlogItem
            title='Urban Garden Gal'
            description='Urban Garden Gal helps gardeners to create a productive and beautiful urban garden, no matter how much garden space they have.'
            favoriteURL='https://urbangardengal.com/climbing-fruit-plants/'
            favoriteAnchor='Climbing fruit plants'
            />
<BlogItem
            title='Garden Savvy'
            description='Garden Savvy is the gardening search engine designed to make it easier for you to find new and exciting gardening suppliers. Whether you’re a gardener looking for rare seeds, or a supplier looking for more exposure, Garden Savvy is here to help. Over 1600+ gardening suppliers and growing!'
            url='https://gardensavvy.com/'
            />
<BlogItem
            title='Urban Gardens'
            description='Welby-nominated Urban Gardens features articles about home and garden, sustainable living and design, architecture, public spaces, design trends, cool products, and garden tourism.'
            url='https://www.urbangardensweb.com/'
            />
<BlogItem
            title='Tropics at Home'
            description='Blogging about growing iconic tropical plants in pots and containers indoors anywhere. In my case in our apartment in Stockholm, Sweden. Tropical plants info, care, ideas and inspiration. Aloha feeling as a part of living!'
            url='https://tropicsathome.com/'
            />
<BlogItem
            title='The Anxious Gardener'
            description='The Anxious Gardener is for anyone who is interested in how an English country garden is managed throughout the year: the plants grown, the toil, the successes, the failures and also the rich wildlife I encountered.  The Anxious Gardener won the Garden Media Guild Award for blog of the year in 2015.'
            favoriteURL='https://theanxiousgardener.com/2018/08/12/at-last-the-priory/'
            favoriteAnchor='At Last, The Priory'
            />
<BlogItem
            title='Succulents And Sunshine'
            description={`Succulents are amazing plants, but if you're not in the "perfect" climate they can be a bit of a challenge to keep alive and thriving. The care techniques at Succulents and Sunshine will help you understand the essential needs of succulents and how to adapt them to your climate. We're convinced succulents can grow anywhere in the world and are here to help you grow them wherever you live.`}
            favoriteURL='https://www.succulentsandsunshine.com/how-to-water-succulent-plants/'
            favoriteAnchor='How to water succulent plants'
            />
<BlogItem
            title='Tender Gardener'
            description='The Tender Gardener explores gardening, permaculture and self sufficiency topics with the goal of inspiring a connection to plants and nature.  Here you will find interesting articles and interviews with both hobbyists and experts, as well as growing guides for beginners.'
            favoriteURL='https://tendergardener.com/garden-stories-james-ip-and-his-balcony-fern-forest/'
            favoriteAnchor='Garden Stories: James Ip and his balcony fern forest'
            />
<BlogItem
            title='Old World Garden Farms'
            description='Old World Garden is a Home & Garden website dedicated to simple living on our farm through DIY, Gardening, Cooking & Canning. We share weekly garden advice, recipes, canning recipes and home DIY projects.'
            url='https://oldworldgardenfarms.com/'
            />
<BlogItem
            title='Susan in the Garden'
            description={`SusansintheGarden.com is a celebration of all aspects of gardening:
            growing your own food, following organic practices, and learning about
            the insects and birds in your garden. Designed by garden writer Susan
            Mulvihill, this website will help you be successful no matter what
            you're growing. It also includes an index to Susan's extensive library
            of how-to-garden videos and her weekly garden columns. Susan lives and
            gardens in Spokane, Washington, in USDA hardiness zone 5b, but the
            information she shares is applicable to gardeners around the world!`}
            favoriteURL='https://www.susansinthegarden.com/guides/organic-pest-control/'
            favoriteAnchor='Organic Pest Control'
            />
<BlogItem
            title='Creative Vegetable Gardener'
            description={`Megan Cain's educational website, The Creative Vegetable Gardener, dishes up no-nonsense advice that helps gardeners grow more food in their gardens. Her mission in life is to help gardeners cut through the noise of all the overcomplicated gardening advice out there by keeping it simple. She offers up smart solutions that work to get you better results from all of your gardening efforts.`}
            favoriteURL='https://www.creativevegetablegardener.com/pruning-indeterminate-tomatoes'
            favoriteAnchor='How to Prune Your Tomato Plants Like an Expert'
            />
<BlogItem
            title='Growing in the Garden'
            description='Organic master gardener in Arizona sharing garden inspiration & helpful tips for growing your own garden.'
            url='https://growinginthegarden.com/'
            />
<BlogItem
            title='Gardenerd'
            description='Are you obsessed with organic gardening, have a thirst for knowledge and a healthy sense of humor? Whether you’re a novice or garden nerd veteran, there’s a place for you here.'
            url='https://gardenerd.com/'
            />
<BlogItem
            title='Chickadee Gardens'
            description='Chickadee Gardens began in 2016 as a dream and two blank acres. Now on this adventure, we have established both sun and shade garden plantings as well as a large vegetable garden and small orchard. We raise honey bees and chickens and have a turkey named Sweet Pea. Our focus is native plantings but we also love (non-invasive) ornamentals. Sustainable gardening is our goal. Changes occur regularly but the focus remains: this garden is for the chickadees (and bees, and bugs, and husband, and cats, chickens, turkey and...)'
            url='https://www.chickadeegardens.com/'
            />
<BlogItem
            title='Country Living in a Cariboo Valley'
            description='Country Living in a Cariboo Valley is all about gardening and homesteading in Zone 3, which is a little trickier than warmer weather areas. Yet Annie and Graham are able to grow about 85% of the food they eat. If you want to learn about freezing and canning your own fresh produce, all the information you need is on the website. Along with vegetable and fruit gardens, they raise chickens, pigs and cattle.'
            favoriteURL='https://countrylivinginacariboovalley.com/preserving-food-freezing-canning-and-pickling-food/'
            favoriteAnchor='Preserving food: freezing, canning and pickling food'
            />
<BlogItem
            title='Growing Family'
            description='I’m Catherine - writer, gardening geek and fan of wellies. Growing Family is my home and garden blog where I share ideas, inspiration and tips for making the most of busy family life.  I firmly believe you don’t have to be an expert to enjoy gardening, and I hope my blog inspires people to have a go and have fun in the process.'
            url='https://growingfamily.co.uk/'
            />
<BlogItem
            title='Gear Trench'
            description='GearTrench provides information related to gardening and home decorations for new and experienced users. The comprehensive and well-researched articles provide practical and helpful ideas, tips, and techniques to get started with gardening and create a beautiful looking home and garden. Our focus is to provide resources to readers to get started with a high chance of success in their garden and home projects.'
            url='https://geartrench.com/'
            />
<BlogItem
            title='Creative Living with Bren Haas'
            description=''
            url='https://brenhaas.com/'
            />
<BlogItem
            title='Gardenista'
            description=''
            url='https://www.gardenista.com/'
            />
<BlogItem
            title='Fine Gardening'
            description=''
            url='https://www.finegardening.com/'
            />
<BlogItem
            title='Permaculture News'
            description=''
            url='https://www.permaculturenews.org/'
            />
<BlogItem
            title='Gardeners World'
            description=''
            url='https://www.gardenersworld.com/'
            />
<BlogItem
            title='Tower Garden'
            description=''
            url='https://www.towergarden.com/'
            />
<BlogItem
            title='Thompson Morgan'
            description=''
            url='https://blog.thompson-morgan.com/'
            />
<BlogItem
            title='Floret Flowers'
            description=''
            url='https://www.floretflowers.com/blog/'
            />
<BlogItem
            title='A Way to Garden'
            description=''
            url='https://awaytogarden.com/'
            />
<BlogItem
            title='Garden Therapy (Canada)'
            description=''
            url='https://gardentherapy.ca/'
            />
<BlogItem
            title='Southern Exposure'
            description=''
            url='https://www.southernexposure.com/blog/'
            />
<BlogItem
            title='Epic Gardening'
            description=''
            url='https://www.epicgardening.com/'
            />
<BlogItem
            title='Sarah Raven'
            description=''
            url='https://www.sarahraven.com/'
            />
<BlogItem
            title='You Grow Girl'
            description=''
            url='http://yougrowgirl.com/'
            />
<BlogItem
            title='Gardenia'
            description=''
            url='https://www.gardenia.net/'
            />
<BlogItem
            title='Premeditated Leftovers'
            description=''
            url='https://premeditatedleftovers.com/'
            />
<BlogItem
            title='Garden Rant'
            description=''
            url='https://www.gardenrant.com/'
            />
<BlogItem
            title='Gardeners Path'
            description=''
            url='https://gardenerspath.com/'
            />
<BlogItem
            title='Root Simple'
            description=''
            url='https://www.rootsimple.com/'
            />
<BlogItem
            title='Plantcare Today'
            description=''
            url='https://plantcaretoday.com/'
            />
<BlogItem
            title='Green Child Magazine'
            description=''
            url='https://www.greenchildmagazine.com/'
            />
<BlogItem
            title='Backyard Gardener'
            description=''
            url='https://www.backyardgardener.com/'
            />
<BlogItem
            title='Garden Collage'
            description=''
            url='https://gardencollage.com/'
            />
<BlogItem
            title='UrbanJungle Bloggers'
            description=''
            url='https://www.urbanjunglebloggers.com/'
            />
<BlogItem
            title='Gardening Channel'
            description=''
            url='https://www.gardeningchannel.com/'
            />
<BlogItem
            title='Savvy Gardening'
            description=''
            url='https://savvygardening.com/'
            />
<BlogItem
            title='Empress of Dirt'
            description=''
            url='https://empressofdirt.net/'
            />
<BlogItem
            title='Garden Betty'
            description=''
            url='https://www.gardenbetty.com/'
            />
<BlogItem
            title='One Hundred Dollars'
            description=''
            url='https://www.onehundreddollarsamonth.com/'
            />
<BlogItem
            title='Get Busy Gardening'
            description=''
            url='https://getbusygardening.com/'
            />
<BlogItem
            title='David Domoney'
            description=''
            url='http://daviddomoney.com/'
            />
<BlogItem
            title='Harvest to Table'
            description=''
            url='https://harvesttotable.com/'
            />
<BlogItem
            title='The Horticult'
            description=''
            url='https://thehorticult.com/'
            />
<BlogItem
            title='Grow a Good Life'
            description=''
            url='https://growagoodlife.com/'
            />
<BlogItem
            title='Tower Garden (Canada)'
            description=''
            url='https://www.towergarden.ca/'
            />
<BlogItem
            title='Pith and Vigor'
            description=''
            url='https://pithandvigor.com/'
            />
<BlogItem
            title='Chiots Run'
            description=''
            url='https://chiotsrun.com/'
            />
<BlogItem
            title='Joy Us Garden'
            description=''
            url='https://www.joyusgarden.com/'
            />
<BlogItem
            title='Gardening Gone Wild'
            description=''
            url='https://gardeninggonewild.com/'
            />
<BlogItem
            title='Garden Drum'
            description=''
            url='http://gardendrum.com/'
            />
<BlogItem
            title='Urban Organic Gardener'
            description=''
            url='https://www.urbanorganicgardener.com/'
            />
<BlogItem
            title='Digging'
            description=''
            url='https://www.penick.net/digging/'
            />
<BlogItem
            title='Plant Lust'
            description=''
            url='https://plantlust.com/blog/'
            />
<BlogItem
            title='Tillys Nest'
            description=''
            url='https://www.tillysnest.com/'
            />
          <BlogItem
            title='Cold Climate Gardening'
            description=''
            url='http://www.coldclimategardening.com/'
            />
<BlogItem
            title='My Tiny Plot'
            description=''
            url='http://mytinyplot.com/'
            />
<BlogItem
            title='Succulents and More'
            description=''
            url='https://www.succulentsandmore.com/'
            />
<BlogItem
            title='Deborah Silver'
            description=''
            url='https://deborahsilver.com/blog/'
            />
<BlogItem
            title='The Middle Sized Garden'
            description=''
            url='https://www.themiddlesizedgarden.co.uk/'
            />
<BlogItem
            title='Debra Lee Baldwin'
            description=''
            url='https://debraleebaldwin.com/'
            />
<BlogItem
            title='Tenth Acre Farm'
            description=''
            url='https://www.tenthacrefarm.com/'
            />
<BlogItem
            title='Veggie Gardening Tips'
            description=''
            url='http://www.veggiegardeningtips.com/'
            />
<BlogItem
            title='Smiling Gardener'
            description=''
            url='https://www.smilinggardener.com/'
            />
<BlogItem
            title='May Dreams Gardens'
            description=''
            url='https://www.maydreamsgardens.com/'
            />
<BlogItem
            title='Growing the Home Garden'
            description=''
            url='https://growingthehomegarden.com/'
            />
<BlogItem
            title='Amateur Gardening'
            description=''
            url='https://www.amateurgardening.com/'
            />
<BlogItem
            title='Aquapoincs Association'
            description=''
            url='https://aquaponicsassociation.org/'
            />
<BlogItem
            title='104 Homestead'
            description=''
            url='https://104homestead.com/'
            />
<BlogItem
            title='Gardening Leave'
            description=''
            url='https://www.gardeningleave.org/'
            />
<BlogItem
            title='Growing with Plants'
            description=''
            url='http://www.growingwithplants.com/'
            />
<BlogItem
            title='Thrifty Homesteader'
            description=''
            url='https://thriftyhomesteader.com/'
            />
<BlogItem
            title='Frustrated Gardener'
            description=''
            url='https://frustratedgardener.com/'
            />
<BlogItem
            title='The Danger Garden'
            description=''
            url='http://www.thedangergarden.com/'
            />
<BlogItem
            title='Big Blog of Gardening'
            description=''
            url='https://www.bigblogofgardening.com/'
            />
<BlogItem
            title='The Impatient Gardener'
            description=''
            url='https://www.theimpatientgardener.com/'
            />
<BlogItem
            title='North Coast Gardening'
            description=''
            url='http://northcoastgardening.com/'
            />
<BlogItem
            title='Seasonal Wisdom'
            description=''
            url='http://www.seasonalwisdom.com/'
            />
<BlogItem
            title='Nothern Homestead'
            description=''
            url='https://northernhomestead.com/'
            />
<BlogItem
            title='AZ Plant Lady'
            description=''
            url='https://www.azplantlady.com/'
            />
<BlogItem
            title='Accessible Gardens'
            description=''
            url='https://accessiblegardens.org/'
            />
<BlogItem
            title='Log House Plants'
            description=''
            url='https://loghouseplants.com/plants/'
            />
<BlogItem
            title='MIgardener'
            description=''
            url='https://migardener.com/'
            />
<BlogItem
            title='Home Garden Joy'
            description=''
            url='https://homegardenjoy.com/site/'
            />
<BlogItem
            title='Cactus Jungle'
            description=''
            url='https://www.cactusjungle.com/'
            />
<BlogItem
            title='Garden Professors'
            description=''
            url='http://gardenprofessors.com/'
            />
<BlogItem
            title='Harmony in the Garden'
            description=''
            url='https://harmonyinthegarden.com/'
            />
<BlogItem
            title='Garden Fundamentals'
            description=''
            url='https://www.gardenfundamentals.com/'
            />
<BlogItem
            title='Central Texas Gardener'
            description=''
            url='https://www.centraltexasgardener.org/'
            />
<BlogItem
            title='The Gardeners Eden'
            description=''
            url='https://www.thegardenerseden.com/'
            />
<BlogItem
            title='Bees and Roses'
            description=''
            url='https://beesandroses.com/'
            />
<BlogItem
            title='The Survival Gardener'
            description=''
            url='http://www.thesurvivalgardener.com/'
            />
<BlogItem
            title='Get Urban Leaf'
            description=''
            url='https://geturbanleaf.com'
            />
<BlogItem
            title='The Unconventional Gardener'
            description=''
            url='https://theunconventionalgardener.com/'
            />
<BlogItem
            title='Tall Clover Farm'
            description=''
            url='https://tallcloverfarm.com/'
            />
<BlogItem
            title='Home Grown Happiness'
            description=''
            url='https://homegrownhappiness.co.nz/'
            />
<BlogItem
            title='Bren Haas'
            description=''
            url='https://brenhaas.com/'
            />
<BlogItem
            title='Clever Bloom'
            description=''
            url='https://cleverbloom.com/'
            />
<BlogItem
            title='Toronto Gardens'
            description=''
            url='https://www.torontogardens.com/'
            />
<BlogItem
            title='What Grows There'
            description=''
            url='http://www.whatgrowsthere.com/'
            />
<BlogItem
            title='Sustainable Market Farming'
            description=''
            url='https://www.sustainablemarketfarming.com/'
            />
<BlogItem
            title='Hoosie Gardener'
            description=''
            url='https://hoosiergardener.com/'
            />
<BlogItem
            title='A Great Garden'
            description=''
            url='https://agreatgarden.com/'
            />
<BlogItem
            title='Small Town Gardener'
            description=''
            url='https://smalltowngardener.com/'
            />
<BlogItem
            title='Farm Food Family'
            description=''
            url='https://farmfoodfamily.com/'
            />
<BlogItem
            title='California Gardening'
            description=''
            url='http://calgardening.com/blog/'
            />
<BlogItem
            title='Sunday Gardener'
            description=''
            url='https://www.sundaygardener.co.uk/'
            />
<BlogItem
            title='The Hypertufa Gardener'
            description=''
            url='https://www.thehypertufagardener.com/'
            />
<BlogItem
            title='Geek Gardener'
            description=''
            url='https://geekgardener.in/'
            />
<BlogItem
            title='Piwakawaka Valley Homestead'
            description='Dana from Piwakawaka Valley Homestead believes that anyone can learn to garden successfully with the right support. From beginners to advanced gardeners, you will find something for you here.'
            url='https://piwakawakavalley.co.nz/garden-resources/'
            />
<BlogItem
            title='Food Forest Plants NZ'
            description=''
            url='https://foodforestplants.co.nz/'
            />
<BlogItem
            title='Urban Vertical Farming Project'
            description=''
            url='https://urbanverticalfarmingproject.com/'
            />
<BlogItem
            title='Miss Smarty Pants'
            description=''
            url='http://misssmartyplants.com/'
            />
<BlogItem
            title='Aussie Organic Gardening'
            description=''
            url='http://aussieorganicgardening.com/'
            />
<BlogItem
            title='Plant Whateer Brings You Joy'
            description=''
            url='http://plantwhateverbringsyoujoy.com/'
            />
<BlogItem
            title='Gardenoid'
            description=''
            url='https://www.gardenoid.com/'
            />
<BlogItem
            title='Skippys Garden'
            description=''
            url='https://skippysgarden.com/'
            />
<BlogItem
            title='Goto 4 Gardening'
            description=''
            url='https://goto4gardening.co.uk/'
            />
<BlogItem
            title='The Garden Diaries'
            description=''
            url='https://thegardendiaries.blog/'
            />
<BlogItem
            title='Gardening Wizards'
            description=''
            url='https://gardeningwizards.com/'
            />
<BlogItem
            title='Try Backard Farming'
            description=''
            url='https://www.trybackyardfarming.com/'
            />
<BlogItem
            title='Davids Giant Vegetables'
            description=''
            url='https://davidsgiantvegetables.com/'
            />
<BlogItem
            title='Wildlife Gardening Forum'
            description=''
            url='http://www.wlgf.org/'
            />
<BlogItem
            title='Women in Horticulture'
            description=''
            url='https://www.womeninhorticulture.com/women-in-horticultue-blog'
            />
<BlogItem
            title='Be GREEN'
            description=''
            url='https://www.begreen.pro/blog'
            />
<BlogItem
            title='Invisible Gardener'
            description=''
            url='https://invisiblegardener.com/blog/'
            />
<BlogItem
            title='Fresh Eggs Daily'
            description=''
            url='https://www.fresheggsdaily.blog/'
            />


{/* American Society for Landscape Architect's The Dirt
GrowerTalk's Acres Online
LandscapeHub's The Weekly Hubdate */}

          {/* <BlogItem
            title=""
            description=""
            url=""
          /> */}
          {/* <BlogItem
            title=""
            description=""
            favoriteURL=""
            favoriteAnchor=""
          /> */}
        </div>
      </Layout>
    )
  }
}

export default NewsLetter

export const NewsLetterQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        name
        description
        siteUrl
      }
    }
    profile: file(relativePath: {eq: "jason-gardenlifepro-profile-pic.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 340) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
